import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const LanguageTemplatesIcon = (props: IconProps) => (
  <ChakraIcon viewBox="0 0 48 48" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6,8.52651283e-14 L42,8.52651283e-14 C45.3137085,8.52651283e-14 48,2.6862915 48,6 L48,42 C48,45.3137085 45.3137085,48 42,48 L6,48 C2.6862915,48 1.13686838e-13,45.3137085 1.13686838e-13,42 L1.13686838e-13,6 C1.13686838e-13,2.6862915 2.6862915,8.52651283e-14 6,8.52651283e-14 Z M9,39 L12.749325,39 L12.749325,9 L9,9 L9,39 Z M14.6248875,12.749325 L14.6248875,29.6239875 C22.1253375,22.1235375 31.49955,37.1244375 39,29.6239875 L38.9982405,12.749325 C31.4995905,20.249775 22.123578,5.24887502 14.6248875,12.749325 L14.6248875,12.749325 Z"
    />
  </ChakraIcon>
)

export default LanguageTemplatesIcon
